export const toggle = (ref, isExpanded) => {
	ref.firstChild.setAttribute("data-icon", `${isExpanded ? "chevron-down" : "chevron-right"}`);
	ref.firstChild.setAttribute("id", `${isExpanded ? "expnded" : "collapsed"}`);
	ref.querySelector("span.person-search-expand-label").textContent = isExpanded ? "Collapse All" : "Expand All";
};